"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permission = void 0;
var Permission;
(function (Permission) {
    Permission["CAN_VIEW_API_KEY"] = "CAN_VIEW_API_KEY";
    // loan applications
    Permission["CAN_ASSIGN_LOAN_APPLICATIONS"] = "CAN_ASSIGN_LOAN_APPLICATIONS";
    Permission["CAN_VIEW_LOAN_APPLICATIONS"] = "CAN_VIEW_LOAN_APPLICATIONS";
    Permission["CAN_EDIT_LOAN_APPLICATIONS"] = "CAN_EDIT_LOAN_APPLICATIONS";
    Permission["CAN_SUBMIT_TEAM_LOAN_APPLICATIONS"] = "CAN_SUBMIT_LOAN_APPLICATIONS";
    // check verification
    Permission["CAN_VERIFY_CHECKS"] = "CAN_VERIFY_CHECKS";
    // pricing
    Permission["CAN_VIEW_PRICING"] = "CAN_VIEW_PRICING";
    Permission["CAN_UPDATE_PRICING"] = "CAN_UPDATE_PRICING";
    // users
    Permission["CAN_CREATE_USERS"] = "CAN_CREATE_USERS";
    Permission["CAN_VIEW_USERS"] = "CAN_VIEW_USERS";
    Permission["CAN_DELETE_USERS"] = "CAN_DELETE_USERS";
    // teams
    Permission["CAN_CREATE_TEAMS"] = "CAN_CREATE_TEAMS";
    Permission["CAN_VIEW_TEAMS"] = "CAN_VIEW_TEAMS";
    Permission["CAN_DELETE_TEAMS"] = "CAN_DELETE_TEAMS";
})(Permission = exports.Permission || (exports.Permission = {}));
